
module.exports = {
  BtnBack: require('./components/BtnBack'),
  BtnDefault: require('./components/BtnDefault'),
  BtnWithIcon: require('./components/BtnWithIcon'),
  BtnAddNew: require('./components/BtnAddNew'),
  BtnOutlined: require('./components/BtnOutlined'),
  BtnDeletable: require('./components/BtnDeletable'),
  BtnTableGlobalRefresh: require('./components/BtnTableGlobalRefresh'),
  BtnTableGlobalDownload: require('./components/BtnTableGlobalDownload'),
  BtnTableGlobalPrint: require('./components/BtnTableGlobalPrint')
}
